module.exports = __webpack_public_path__ + "img/img5.ce6c644e.svg";